import { useEffect } from 'react'
import { getListContractModalitys } from '../../../services/sBook/contractModalitys.service';

const useGetContractModalitys = (contractModalitys, setContractModalitys) => {    
    useEffect(()=> {
        const getData = async () => {
            try {
                let serviceResponse = await getListContractModalitys();
                const response = serviceResponse.data ?? serviceResponse;
    
                if (response.succeeded ?? true) {
                    setContractModalitys(response.data ?? response);
                }
                else {
                    setContractModalitys([]);
                }
            }
            catch (error) {
                setContractModalitys([]);
            }
        }
        
        if (contractModalitys === null) {
            getData()
        }
    }, [contractModalitys, setContractModalitys]);
}

export {
    useGetContractModalitys
}